import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useStores } from "../../stores";
import { AppConfig } from "../../AppConfig";
import { ShowAlert } from "../../utilities/Functions";

const siteTitle = AppConfig?.Title;

export default function ResetPasswordPage() {
  const [userEmail, setUserEmail] = React.useState("");

  const { authStore } = useStores();
  const { resetPassword } = authStore;

  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!userEmail) {
      ShowAlert.Warning("Email field is required.");
      return;
    }

    let req = { userEmail };
    resetPassword(req, () => {
      navigate("/");
    });
  };

  return (
    <>
      <title>{siteTitle} - Login</title>

      <section className="login-area ptb-60">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="login-content">
                <div className="section-title">
                  <h2>
                    <span className="dot"></span>
                    <span id="lbl_login_title">Recover Password</span>
                  </h2>
                </div>

                <form
                  className="login-form"
                  autoComplete="off"
                  onSubmit={handleSubmit}
                >
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your email"
                      id="email"
                      name="email"
                      required={true}
                      value={userEmail}
                      onChange={(e) => setUserEmail(e.target.value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    id="lbl_login_loginbtn"
                  >
                    Recover Password
                  </button>

                  <Link to={`/login`} className="forgot-password">
                    Login
                  </Link>
                </form>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="new-customer-content" style={{ display: "none" }}>
                <div className="section-title">
                  <h2>
                    <span className="dot"></span>
                    <span id="lbl_login_newcustomer">New Customer</span>
                  </h2>
                </div>

                <span>Create an Account</span>
                <p id="lbl_login_inst_singup">
                  Sign up for a free account at our store. Registration is quick
                  and easy. It allows you to be able to order from our shop. To
                  start shopping click register.
                </p>
                <Link
                  to={`/signup`}
                  className="btn btn-light"
                  id="lbl_login_createacnt_2"
                >
                  Create an Account
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
